import { render, staticRenderFns } from "./CouresList.vue?vue&type=template&id=a1e354fe"
import script from "./CouresList.vue?vue&type=script&lang=js"
export * from "./CouresList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports